export const LOCATION_TYPES = ['HYPER', 'SUPER']
